import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div className='footer'>
      <div className='child-footer'>
        <Link to='/shop' className='nav-footer'>
          <span>
            <img src='/svg/Buy.svg' alt='buy' className='icon-1' />
          </span>
          <span>فروشگاه</span>
        </Link>
        <Link to='/profile' className='nav-footer'>
          <span>
            <img src='/svg/Profile.svg' alt='profile' className='icon-1' />
          </span>
          <span>پروفایل</span>
        </Link>
        <Link to='/service' className='nav-footer d-none d-sm-flex'>
          <span>خدمات ما</span>
        </Link>
        <Link to='/cart' className='nav-footer'>
          <span>
            <img src='/svg/Bag.svg' alt='bag' className='icon-1' />
          </span>
          <span>سبد خرید</span>
        </Link>
        {/* <Link to='/service' className='nav-footer d-sm-none'>
          <span>
            <RiCustomerService2Fill size={25} />
          </span>
          <span>خدمات</span>
        </Link> */}
        <Link to='/' className='nav-footer'>
          <span>
            <img src='/svg/Home.svg' alt='home' className='icon-1' />
          </span>
          <span>خانه</span>
        </Link>
      </div>
    </div>
  );
};
export default Footer;
